import { Component, Input, OnInit } from '@angular/core'
import { UntypedFormArray, UntypedFormGroup } from '@angular/forms'
import { TranslateService } from '@ngx-translate/core'
import { DISABILITY_OPTIONS } from '@se-po/shared-data-access-models'
import { BaseValueAccessorDirective } from '@se-po/shared-ui-form-directives'
import { SeFeSelectOption } from 'se-fe-form-field-select'
import { SeFeTranslationsLoader } from 'se-fe-translations'

@Component({
  selector: 'se-po-disability-select',
  templateUrl: './disability-select.component.html',
  styleUrls: ['./disability-select.component.scss'],
  hostDirectives: [BaseValueAccessorDirective],
  standalone: false,
})
export class DisabilitySelectComponent implements OnInit {
  @Input() public seFeDataLabel?: string

  public disabilityStatusOptions: SeFeSelectOption[] = []
  public loaded: boolean
  public ngControl = BaseValueAccessorDirective.ngControl(this) // get the forwarded control

  constructor(private seFeTranslationsLoader: SeFeTranslationsLoader,
              private translateService: TranslateService
  ) { }

  public get form(): UntypedFormGroup | UntypedFormArray {
    return this.ngControl?.control?.parent
  }

  public ngOnInit(): void {
    this.loaded = false
    this.initTranslations()
  }

  public initTranslations(): void {
    this.seFeTranslationsLoader.load('shared/ui-disability-select/assets/translations').then(() => {
      DISABILITY_OPTIONS.forEach(val => {
        this.disabilityStatusOptions.push({
          label: this.translateService.instant(`SE_PO_UI_DISABILITY_SELECT.STATUS.${val}`),
          value: val
        })
      })
      this.loaded = true
    })
  }
}
